import React from 'react';
import getGatewayUri from '../store/services/getGatewayUri';
import getPartnerUri from '../store/services/getPartnerUri';

export const SingleSignOn = () => {
  window.location.href = `${getGatewayUri()}/login?prompt=none&returnTo=${encodeURIComponent(getPartnerUri())}`;

  return <div></div>;
};

export default SingleSignOn;
